import Component from "../../../../js/assets/component.js"
import Device from "../../../../js/assets/device.js"
import SlideShowItem from "./slideshow_item.js"

class SlideShowBody extends Component {
  constructor(el) {
    super(el);
  }

  data() {
    return {
      "SLIDE_TOTAL_NUM": null,
      "device_mode": null,
      "activeIndex": null,
      "startLeft": 0,
      "slideDir": "left",
      "slideContainerWidth": 0,
      "isSwiped": false
    }
  }

  changed() {
    return {
      "SLIDE_TOTAL_NUM": () => {
        this.noChange('SLIDE_TOTAL_NUM')
      },
      "device_mode": (val) => {
        this.calcSlideContainerWidth()
      },
      "activeIndex": async (index, prev) => {

        if(this.$data.SLIDE_TOTAL_NUM > 3){
          //adjust container position
          await this.setSlideContainerPosition(index, prev, this.$data.slideDir)
          //load image
          this.loadImage(index)
          //activate
          this.activateItem(index)
          //slide to index
          await this.slideTo(index)
        }else{
          //activate
          this.activateItem(index)
        }
      }
    }
  }

  async mounted() {
    var self = this

    //members
    this.$slideContainerOriginal = null
    this.slideItemsOriginal = []
    this.$slideContainerCopy_01 = null
    this.slideItemsCopy_01 = []
    this.$slideContainerCopy_02 = null
    this.slideItemsCopy_02 = []
    this.$mainRollContainer = null
    this.$leftContainer = null
    this.$rightContainer = null

    //container original
    this.$slideContainerOriginal = this.$el.find("[data-role='slideShow_items']")
    this.$slideContainerOriginal.find("li").each(function (i) {
      self.slideItemsOriginal.push(new SlideShowItem($(this).get(0)))

      let $anchor = $(this).find("a")
      if($anchor.length === 0){
        return
      }

      let href = $anchor.attr("href")
      let target = $anchor.attr("target")

      $anchor.swipe({
        tap: function(){
          if(self.$data.isSwiped === true){
            e.preventDefault()
            e.stopPropagation()
            return
          }
          self.openURL(href, target)
        }
      })
    })
    this.$data.SLIDE_TOTAL_NUM = this.slideItemsOriginal.length
    if(this.$data.SLIDE_TOTAL_NUM > 1 ){
      //swipe
      this.$el.swipe({
        triggerOnTouchLeave: true,
        triggerOnTouchEnd: true,
        threshold: 0,
        excludedElements:"",
        allowPageScroll: "vertical",
        swipeStatus: function (event, phase, direction, distance, duration, fingers, fingerData, currentDirection){
          self.swipeStatusHandler(event, phase, direction, distance, duration, fingers, fingerData, currentDirection)
        }
      });

      //watch event
      this.addEventListener("swipeStart", ()=>{

      })
      this.addEventListener("swipeEnd", (data)=>{
        if(data.direction === null){
          self.$data.isSwiped = false
          return
        }
        self.$data.isSwiped = true
      })
      this.addEventListener("swipeMove", (data)=>{
      })

      this.$mainRollContainer = this.$slideContainerOriginal
      this.$mainRollContainer.addClass("-mainRoll")
      this.mainSlideItems = this.slideItemsOriginal

      //event listener
      Device.addEventListener("device_mode", (data) => {
        this.$data.device_mode = data
      })

      this.$data.device_mode = Device.$data.device_mode
    }
    if (this.$data.SLIDE_TOTAL_NUM <= 3) {
      return
    }

    //container copy 01
    this.$slideContainerCopy_01 = this.$slideContainerOriginal.clone(true)
    this.$slideContainerCopy_01.find("li").each(function (i) {
      self.slideItemsCopy_01.push(new SlideShowItem($(this).get(0)))

      let $anchor = $(this).find("a")
      if($anchor.length === 0){
        return
      }

      let href = $anchor.attr("href")
      let target = $anchor.attr("target")

      $anchor.swipe({
        tap: function(){
          if(self.$data.isSwiped === true){
            e.preventDefault()
            e.stopPropagation()
            return
          }
          self.openURL(href, target)
        }
      })
    })
    this.$slideContainerOriginal.before(this.$slideContainerCopy_01)

    //container copy 02
    this.$slideContainerCopy_02 = this.$slideContainerOriginal.clone(true)
    this.$slideContainerCopy_02.find("li").each(function (i) {
      self.slideItemsCopy_02.push(new SlideShowItem($(this).get(0)))

      let $anchor = $(this).find("a")
      if($anchor.length === 0){
        return
      }

      let href = $anchor.attr("href")
      let target = $anchor.attr("target")

      $anchor.swipe({
        tap: function(){
          if(self.$data.isSwiped === true){
            e.preventDefault()
            e.stopPropagation()
            return
          }
          self.openURL(href, target)
        }
      })
    })
    this.$slideContainerOriginal.after(this.$slideContainerCopy_02)

    //set roll
    this.$mainRollContainer = this.$slideContainerOriginal
    this.mainSlideItems = this.slideItemsOriginal
    this.$leftContainer = this.$slideContainerCopy_01
    this.leftSlideItems = this.slideItemsCopy_01
    this.$rightContainer = this.$slideContainerCopy_02
    this.rightSlideItems = this.slideItemsCopy_02
    this.$mainRollContainer.addClass("-mainRoll")
    this.$rightContainer.removeClass("-mainRoll")
    this.$leftContainer.removeClass("-mainRoll")


    //init

    //event listener
    Device.addEventListener("device_mode", (data) => {
      this.$data.device_mode = data
    })
    window.addEventListener("resize", () => {
      this.calcSlideContainerWidth()
    })

    this.$data.device_mode = Device.$data.device_mode
    this.calcSlideContainerWidth()

    //init position
    // await this.animationAllOff()
    this.$leftContainer.css({
      "left": (this.$data.SLIDE_TOTAL_NUM * -100) + "%"
    })
    this.$rightContainer.css({
      "left": (this.$data.SLIDE_TOTAL_NUM * 100) + "%"
    })
    // await this.animationAllOn()
  }

  openURL(url, target){

    if(target !== "_blank"){
      location.href = url
    }else{
      window.open(url)
    }
  }

  calcSlideContainerWidth() {
    // if (this.$data.device_mode === "sp") {
    //   this.$data.slideContainerWidth = Number(this.$slideContainerOriginal.width() * this.$data.SLIDE_TOTAL_NUM)
    // } else {
      this.$data.slideContainerWidth = Number(this.$slideContainerOriginal.width() * this.$data.SLIDE_TOTAL_NUM)
    // }
  }

  /*
  * 選択中のスライドをactive状態にする
  */
  activateItem(index) {
    for (let i = 0; i < this.mainSlideItems.length; i++) {
      if (i === index) {
        this.mainSlideItems[i].activate()
      } else {
        this.mainSlideItems[i].inActivate()
      }
      if(this.rightSlideItems){
        this.rightSlideItems[i].inActivate()
      }
      if(this.leftSlideItems){
        this.leftSlideItems[i].inActivate()
      }
    }
  }

  /*
  * index: 次のスライド番号
  * prev:前のスライド番号
  * dir: スライド方向
  */
  async setSlideContainerPosition(index, prev, dir) {
    //
    let isSwitchMainRoll = false
    switch (dir) {
      case "left":
        if (index - prev < 0) {
          isSwitchMainRoll = true
        }
        break
      case "right":
        if (index - prev > 0) {
          isSwitchMainRoll = true
        }
        break
    }

    if (isSwitchMainRoll === false) {
      return
    }

    //switchRoll
    if (dir === "left") {
      this.switchMainRoll("right")
    } else {
      this.switchMainRoll("left")
    }

    //set position
    let mainRollLeft = Number(this.$mainRollContainer.css("left").replace(/(%|px)/, ""))

    this.$leftContainer.css({
      "left": mainRollLeft - this.$data.slideContainerWidth
    })
    this.$rightContainer.css({
      "left": mainRollLeft + this.$data.slideContainerWidth
    })
  }

  /*
  * 3つの位置関係を切り替える
  */
  switchMainRoll(dir) {
    switch (dir) {
      case "right":
        if (this.$rightContainer === this.$slideContainerCopy_02) {
          this.$mainRollContainer = this.$slideContainerCopy_02
          this.$rightContainer = this.$slideContainerCopy_01
          this.$leftContainer = this.$slideContainerOriginal

          this.mainSlideItems = this.slideItemsCopy_02
          this.rightSlideItems = this.slideItemsCopy_01
          this.leftSlideItems = this.slideItemsOriginal
        } else if (this.$rightContainer === this.$slideContainerCopy_01) {
          this.$mainRollContainer = this.$slideContainerCopy_01
          this.$rightContainer = this.$slideContainerOriginal
          this.$leftContainer = this.$slideContainerCopy_02

          this.mainSlideItems = this.slideItemsCopy_01
          this.rightSlideItems = this.slideItemsOriginal
          this.leftSlideItems = this.slideItemsCopy_02
        } else if (this.$rightContainer === this.$slideContainerOriginal) {
          this.$mainRollContainer = this.$slideContainerOriginal
          this.$rightContainer = this.$slideContainerCopy_02
          this.$leftContainer = this.$slideContainerCopy_01

          this.mainSlideItems = this.slideItemsOriginal
          this.rightSlideItems = this.slideItemsCopy_02
          this.leftSlideItems = this.slideItemsCopy_01
        }
        break
      case "left":
        if (this.$leftContainer === this.$slideContainerCopy_02) {
          this.$mainRollContainer = this.$slideContainerCopy_02
          this.$rightContainer = this.$slideContainerCopy_01
          this.$leftContainer = this.$slideContainerOriginal

          this.mainSlideItems = this.slideItemsCopy_02
          this.rightSlideItems = this.slideItemsCopy_01
          this.leftSlideItems = this.slideItemsOriginal
        } else if (this.$leftContainer === this.$slideContainerCopy_01) {
          this.$mainRollContainer = this.$slideContainerCopy_01
          this.$rightContainer = this.$slideContainerOriginal
          this.$leftContainer = this.$slideContainerCopy_02

          this.mainSlideItems = this.slideItemsCopy_01
          this.rightSlideItems = this.slideItemsOriginal
          this.leftSlideItems = this.slideItemsCopy_02
        } else if (this.$leftContainer === this.$slideContainerOriginal) {
          this.$mainRollContainer = this.$slideContainerOriginal
          this.$rightContainer = this.$slideContainerCopy_02
          this.$leftContainer = this.$slideContainerCopy_01

          this.mainSlideItems = this.slideItemsOriginal
          this.rightSlideItems = this.slideItemsCopy_02
          this.leftSlideItems = this.slideItemsCopy_01
        }
        break
    }
    this.$mainRollContainer.addClass("-mainRoll")
    this.$rightContainer.removeClass("-mainRoll")
    this.$leftContainer.removeClass("-mainRoll")
  }

  /*
  * activeなスライド+2のスライドの画像をプリロード
  */
  loadImage(index) {
    let index1, index2

    if(this.$data.SLIDE_TOTAL_NUM <= 3){
      return
    }

    this.mainSlideItems[index].loadImage()

    if (index === this.$data.SLIDE_TOTAL_NUM - 2) {
      index1 = index + 1
      index2 = 0
      this.leftSlideItems[index1].loadImage()
      this.mainSlideItems[index2].loadImage()
    } else if (index === this.$data.SLIDE_TOTAL_NUM - 1) {
      index1 = 0
      index2 = 1
      this.mainSlideItems[index1].loadImage()
      this.rightSlideItems[index2].loadImage()
    } else {
      index1 = index + 1
      index2 = index + 2
      this.mainSlideItems[index1].loadImage()
      this.mainSlideItems[index2].loadImage()
    }
  }

  /*
  * スライド
  */
  async slideTo(index) {
    let mainRollLeft = (index * -100)

    this.$mainRollContainer
      .stop(false,false)
      .animate({
        left: mainRollLeft + "%"
      },{
        duration: 1000,
        easing: "easeOutCirc"
      })
    this.$leftContainer
      .stop(false, false)
      .animate({
        left: (mainRollLeft - this.$data.SLIDE_TOTAL_NUM * 100) + "%"
      }, {
          duration: 1000,
          easing: "easeOutCirc"
        })
    this.$rightContainer
      .stop(false, false)
      .animate({
        left: (mainRollLeft + this.$data.SLIDE_TOTAL_NUM * 100) + "%"
      }, {
          duration: 1000,
          easing: "easeOutCirc"
        })

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 500)
    })
  }

  moveTo(direction, startLeft, distance) {
    let coefficient = 1
    switch (direction) {
      case "right":
        coefficient = 1
        break
      case "left":
        coefficient = -1
        break
    }
    let posLeft = Number(startLeft) + (coefficient * distance)
    this.$mainRollContainer
      .css({
        "left": posLeft + "px"
      })
    this.$leftContainer
      .css({
        "left": (posLeft - this.$data.slideContainerWidth) + "px"
      })
    this.$rightContainer
      .css({
        "left": (posLeft + this.$data.slideContainerWidth) + "px"
      })
  }

  /*
  * スワイプ
  */
  async swipeStatusHandler(event, phase, direction, distance, duration, fingers, fingerData, currentDirection) {
    if(this.$data.device_mode !== "sp"){
      return
    }

    if (phase === "start") {
      this.dispatchEvent("swipeStart")
      // await this.animationAllOff()
      this.$data.startLeft = Number(this.$mainRollContainer.css("left").replace(/(%|px)/, ""))
    }
    if (distance < 10) {
      this.dispatchEvent("swipeEnd", {
        "direction": null
      })
      return
    }
    if (direction === "up" || direction === "bottom"){
      this.$data.isSwiped = true
      return false
    }
    if (phase === "move" && (direction === "left" || direction === "right")) {
      this.dispatchEvent("swipeMove", {
        "direction": direction,
        "startLeft": this.$data.startLeft,
        "distance": distance
      })
    } else if (phase == "cancel" || phase == "end") {
      this.dispatchEvent("swipeEnd", {
        "direction": direction
      })
      this.dispatchEvent(direction)
    }
  }
}

export default SlideShowBody
